import { render, staticRenderFns } from "./plane_type.vue?vue&type=template&id=2b110fe2&scoped=true&"
import script from "./plane_type.vue?vue&type=script&lang=js&"
export * from "./plane_type.vue?vue&type=script&lang=js&"
import style0 from "./plane_type.vue?vue&type=style&index=0&id=2b110fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b110fe2",
  null
  
)

export default component.exports